export const authUrl = '/auth';
export const defaultRequestTimeout = 28000;